import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const InsumosOrdemProducao = () => {
    const printRef = React.useRef();

    // Função para imprimir apenas a área desejada
    const handlePrint = () => {
      if (!printRef.current) return;
      const printContents = printRef.current.innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // Garante que a tela volte ao normal após impressão
    };
  const [ordens, setOrdens] = useState([]);
  const [ordemId, setOrdemId] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [insumos, setInsumos] = useState([]);
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [ordemSelecionada, setOrdemSelecionada] = useState(null);
  const [grade, setGrade] = useState(null);
  const [gradeLoading, setGradeLoading] = useState(false);
  const [gradeError, setGradeError] = useState(null);
  const [fichaModalOpen, setFichaModalOpen] = useState(false);
  const [fichaDetalhes, setFichaDetalhes] = useState([]);
  const [fichaLoading, setFichaLoading] = useState(false);
  const navigate = useNavigate();

  const normalizarInsumo = (insumo = {}) => {
    const nomeMaterial =
      insumo.descricaoCompleta ||
      insumo.nomeMateriaPrima ||
      [insumo.materiaPrima, insumo.cor].filter(Boolean).join(' ') ||
      insumo.materiaPrima ||
      '-';

    let consumo = '-';
    if (insumo.consumoFormatado && String(insumo.consumoFormatado).trim() !== '') {
      consumo = String(insumo.consumoFormatado);
    } else if (insumo.consumoTotal != null && Number.isFinite(Number(insumo.consumoTotal))) {
      consumo = Number(insumo.consumoTotal).toFixed(4);
    }

    if (consumo !== '-' && insumo.unidade) {
      consumo = `${consumo} ${insumo.unidade}`;
    }

    return {
      nomeMaterial,
      codigo: insumo.codigo ?? '-',
      unidade: insumo.unidade || '-',
      consumo,
      componentes: insumo.componentes || '-'
    };
  };

  useEffect(() => {
    // Carregar ordens de produção da API
    const fetchOrdens = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${URLManager.getBaseURL()}/ordemProducao/listar`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar ordens de produção');
        const data = await response.json();
        console.log('Ordens de produção retornadas:', data);
        setOrdens(data);
        if (!data || data.length === 0) {
          setMensagem('Nenhuma ordem de produção encontrada para sua empresa/usuário.');
        }
      } catch (error) {
        setMensagem(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchOrdens();
  }, []);

  const consultarInsumos = async () => {
    if (!ordemId) {
      setMensagem('Selecione a ordem de produção.');
      setInsumos([]);
      return;
    }
    setMensagem('');
    setInsumos([]);
    setLoading(true);
    try {
      const url = `${URLManager.getBaseURL()}/ordemProducao/insumos/${ordemId}`;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      const result = await response.json();
      if (response.ok) {
        const listaInsumos = Array.isArray(result)
          ? result
          : (Array.isArray(result?.insumos)
              ? result.insumos
              : (Array.isArray(result?.materiasPrimas) ? result.materiasPrimas : []));

        setInsumos(listaInsumos);
        if (listaInsumos.length === 0) setMensagem('Nenhum insumo encontrado para esta ordem.');
      } else {
        setMensagem('Erro ao consultar insumos.');
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para buscar detalhes da ficha técnica
  const buscarDetalheFichaTecnica = async () => {
    if (!ordemSelecionada) {
      setMensagem('Selecione uma ordem de produção primeiro.');
      return;
    }
    
    // Tentar identificar o ID do produto de várias formas possíveis
    const produtoId = 
      ordemSelecionada.idProduto || 
      ordemSelecionada.produto?.id || 
      ordemSelecionada.produto?.idProduto ||
      (ordemSelecionada.idProduto ? ordemSelecionada.idProduto : null);
    
    console.log('Ordem selecionada:', ordemSelecionada);
    console.log('ID do produto identificado:', produtoId);
    console.log('Produto completo:', ordemSelecionada.produto);
    
    if (!produtoId) {
      setMensagem('Produto não identificado na ordem selecionada. Verifique se a ordem possui um produto associado.');
      return;
    }
    
    setFichaLoading(true);
    setFichaModalOpen(true);
    setMensagem('');
    
    try {
      // Tentar primeiro endpoint
      let fichas = null;
      let fichaResponse = await fetch(`${URLManager.getBaseURL()}/fichaTecnica/produto/${produtoId}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      
      console.log('Resposta /fichaTecnica/produto/:', fichaResponse.status);
      
      if (fichaResponse.ok) {
        fichas = await fichaResponse.json();
        console.log('Fichas retornadas (endpoint 1):', fichas);
      } else {
        // Tentar endpoint alternativo com base em idFichaTecnica da ordem
        if (ordemSelecionada.idFichaTecnica) {
          console.log('Tentando com idFichaTecnica da ordem:', ordemSelecionada.idFichaTecnica);
          fichaResponse = await fetch(`${URLManager.getBaseURL()}/fichaTecnica/${ordemSelecionada.idFichaTecnica}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
            }
          });
          
          if (fichaResponse.ok) {
            const ficha = await fichaResponse.json();
            fichas = Array.isArray(ficha) ? ficha : [ficha];
            console.log('Fichas retornadas (endpoint 2 - por ID):', fichas);
          }
        }
        
        // Se ainda não encontrou, tentar listar todas
        if (!fichas) {
          console.log('Tentando listar todas as fichas técnicas');
          fichaResponse = await fetch(`${URLManager.getBaseURL()}/fichaTecnica/listar`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
            }
          });
          
          if (fichaResponse.ok) {
            const todasFichas = await fichaResponse.json();
            console.log('Todas as fichas técnicas:', todasFichas);
            
            // Filtrar pelo produto
            fichas = todasFichas.filter(f => 
              f.idProduto === produtoId || 
              f.produto?.id === produtoId ||
              f.id === ordemSelecionada.idFichaTecnica
            );
            
            console.log('Fichas filtradas para este produto:', fichas);
          }
        }
      }
      
      if (!fichas || fichas.length === 0) {
        setFichaDetalhes([]);
        setFichaLoading(false);
        setMensagem('Nenhuma ficha técnica encontrada para este produto.');
        return;
      }
      
      // Buscar itens da ficha técnica
      const ficha = fichas[0];
      const fichaId = ficha.id || ficha.idFichaTecnica || ficha.fichaId;
      
      console.log('Ficha técnica obtida:', ficha);
      console.log('ID da ficha técnica:', fichaId);
      
      if (!fichaId) {
        setFichaDetalhes([]);
        setFichaLoading(false);
        setMensagem('ID da ficha técnica não identificado.');
        return;
      }
      
      // Endpoint correto: /items-ficha-tecnica/{fichaId}/{produtoId}
      const itensResponse = await fetch(`${URLManager.getBaseURL()}/items-ficha-tecnica/${fichaId}/${produtoId}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      
      console.log('Resposta itens da ficha:', itensResponse.status);
      
      if (!itensResponse.ok) {
        const errorText = await itensResponse.text();
        console.error('Erro ao buscar itens:', itensResponse.status, errorText);
        throw new Error('Erro ao buscar itens da ficha técnica');
      }
      
      const itensData = await itensResponse.json();
      console.log('Resposta completa itens:', itensData);
      
      // A resposta contém itemsFichaTecnicas como array
      const itens = itensData.itemsFichaTecnicas || itensData || [];
      console.log('Itens da ficha técnica:', itens);
      setFichaDetalhes(itens);
      
    } catch (error) {
      console.error('Erro ao buscar detalhes da ficha:', error);
      setFichaDetalhes([]);
      setMensagem(`Erro ao carregar ficha técnica: ${error.message}`);
    } finally {
      setFichaLoading(false);
    }
  };

  // Função para imprimir fichas técnicas
  const handlePrintFichas = () => {
    const fichasDiv = document.getElementById('fichas-para-imprimir');
    if (!fichasDiv) {
      return;
    }

    const printWindow = window.open('', '_blank', 'width=1024,height=768');
    if (!printWindow) {
      window.print();
      return;
    }

    const content = fichasDiv.innerHTML;
    printWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Fichas Tecnicas</title>
          <style>
            @page { size: A4; margin: 4mm; }
            body { font-family: Arial, sans-serif; margin: 0; padding: 0; color: #222; font-size: 8.5px; line-height: 1.1; }
            .ficha-item {
              display: block;
              width: 100%;
              box-sizing: border-box;
              border: 1px solid #ddd;
              margin: 0 0 2.5mm 0;
              padding: 1.5mm;
              break-inside: avoid;
              page-break-inside: avoid;
            }
            .ficha-item > div { margin-bottom: 3px !important; }
            .ficha-item table { width: 100%; border-collapse: collapse; font-size: 8px; }
            .ficha-item th, .ficha-item td { border: 1px solid #ddd; padding: 1px; text-align: center; }
            .ficha-item .MuiTypography-root { font-size: 8.5px !important; margin-bottom: 2px !important; line-height: 1.1 !important; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  // Buscar grade planejada para a ordem selecionada
  useEffect(() => {
    if (!ordemId) {
      setGrade(null);
      setGradeError(null);
      return;
    }
    let cancelled = false;
    setGradeLoading(true);
    setGradeError(null);
    (async () => {
      try {
        const url = `${URLManager.getBaseURL()}/ordemProducao/grade/${ordemId}`;
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) {
          // Se o endpoint não existir (404) tentamos extrair a grade a partir
          // do objeto da ordem que já foi carregado (campo `gradeQuantidade`).
          if (response.status === 404) {
            if (!cancelled) {
              console.warn(`Grade não encontrada para ordem ${ordemId} (404) — tentando fallback)`);
              // busca a ordem selecionada ou procura no array `ordens`
              const ordemObj = ordemSelecionada || ordens.find(o => String(o.id) === String(ordemId));
              let parsed = null;
              if (ordemObj) {
                const gq = ordemObj.gradeQuantidade || ordemObj.grade_quantidade || ordemObj.gradeQuantidadeJson || ordemObj.grade_numeracao_json;
                if (gq) {
                  try {
                    parsed = typeof gq === 'string' ? JSON.parse(gq) : gq;
                  } catch (e) {
                    console.warn('Falha ao parsear gradeQuantidade da ordem (fallback):', e);
                    parsed = null;
                  }
                }
              }
              if (parsed) {
                setGrade(parsed);
                setGradeError(null);
              } else {
                setGrade(null);
                setGradeError(null);
              }
            }
            return;
          }
          const t = await response.text();
          throw new Error(t || 'Erro ao carregar grade');
        }
        const data = await response.json();
        if (!cancelled) setGrade(data);
      } catch (err) {
        if (!cancelled) {
          setGradeError(err.message || 'Erro inesperado');
          setGrade(null);
        }
      } finally {
        if (!cancelled) setGradeLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [ordemId, ordens, ordemSelecionada]);

  return (
    <>
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          
          /* Make the Dialog and content visible */
          .MuiDialog-paper,
          .MuiDialogContent-root {
            visibility: visible !important;
          }
          
          #fichas-para-imprimir, #fichas-para-imprimir * {
            visibility: visible !important;
          }
          
          /* Proper styling for print */
          .MuiDialog-paper {
            position: relative !important;
            max-width: 100% !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            box-shadow: none !important;
          }
          
          .MuiDialogTitle-root,
          .MuiDialogActions-root {
            display: none !important;
          }

          .MuiDialogContent-root {
            max-height: none !important;
            overflow: visible !important;
          }
          
          #fichas-para-imprimir {
            max-height: none !important;
            overflow: visible !important;
            position: static !important;
            width: 100% !important;
            display: block !important;
            padding: 0 !important;
          }
          
          /* Each ficha sheet - allow to break to new page if needed */
          #fichas-para-imprimir > div {
            display: block !important;
            width: 100% !important;
            background: white !important;
            margin: 0 0 20px 0 !important;
            padding: 15px !important;
            border: 1px solid #ddd !important;
            box-sizing: border-box !important;
            page-break-inside: avoid !important;
            page-break-after: auto !important;
            break-after: auto !important;
          }
        }
      `}</style>
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: 32, minWidth: 350, maxWidth: 700 }}>
          <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#2d3a4b' }}>Insumos da Ordem de Produção</h2>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Ordem de Produção:</label><br />
          <Autocomplete
            options={ordens.filter(o => Number(o.mapa) > 0)}
            getOptionLabel={option => {
              if (!option) return '';
              if (typeof option === 'string') return option;
              // Exibe: Mapa #<mapa> | <nome do produto>
              const mapa = option.mapa || '';
              let nomeProduto = option.nomeProduto || option.nomeModelo || option.nome || option.descricao || (option.produto && (option.produto.nomeModelo || option.produto.nome || option.produto.descricao)) || '';
              let label = '';
              if (mapa) label += `Mapa #${mapa}`;
              if (nomeProduto) label += ` | ${nomeProduto}`;
              return label.trim() || JSON.stringify(option);
            }}
            filterOptions={(options, state) =>
              options.filter(option => {
                const search = state.inputValue.toLowerCase();
                const mapa = String(option.mapa || '').toLowerCase();
                let nomeProduto = option.nomeProduto || option.nomeModelo || option.nome || option.descricao || (option.produto && (option.produto.nomeModelo || option.produto.nome || option.produto.descricao)) || '';
                nomeProduto = nomeProduto.toLowerCase();
                return mapa.includes(search) || nomeProduto.includes(search);
              })
            }
            value={ordens.find(o => String(o.id) === String(ordemId)) || null}
            onChange={(event, newValue) => {
              setOrdemId(newValue ? newValue.id : null);
              setOrdemSelecionada(newValue || null);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Digite para buscar por mapa ou produto..." variant="outlined" size="small" autoFocus />
            )}
            isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
            noOptionsText="Nenhuma ordem encontrada"
            sx={{ width: '100%', marginTop: 1 }}
            autoHighlight
            openOnFocus
            clearOnBlur={false}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginBottom: 18 }}>
          <button
            onClick={consultarInsumos}
            disabled={loading}
            style={{
              flex: 1,
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Buscando...' : 'Listar Insumos'}
          </button>
          
          <button
            onClick={buscarDetalheFichaTecnica}
            disabled={!ordemSelecionada || loading}
            style={{
              flex: 1,
              background: ordemSelecionada ? '#4caf50' : '#ccc',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: ordemSelecionada && !loading ? 'pointer' : 'not-allowed',
            }}
          >
            📋 Ver Ficha Técnica
          </button>
          </div>
          <button
            onClick={() => navigate(-1)}
            style={{
              width: '100%',
              background: '#607d8b',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: 10
            }}
          >
            Voltar
          </button>
          {mensagem && (
            <div style={{
              marginTop: 10,
              color: insumos.length ? '#388e3c' : '#d32f2f',
              background: insumos.length ? '#e8f5e9' : '#ffebee',
              borderRadius: 6,
              padding: 10,
              textAlign: 'center',
              fontWeight: 500
            }}>
              {mensagem}
              {ordens && ordens.length === 0 && (
                <div style={{ marginTop: 8, color: '#d32f2f', fontSize: 14 }}>
                  Nenhuma ordem foi retornada pela API. Verifique se há ordens cadastradas para sua empresa/usuário.<br/>
                  Veja o console do navegador para detalhes.
                </div>
              )}
            </div>
          )}
          {insumos.length > 0 && ordemSelecionada && (
            <>
              <button
                onClick={handlePrint}
                style={{
                  marginTop: 20,
                  marginBottom: 10,
                  background: '#1976d2',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  padding: '10px 24px',
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: 'pointer',
                  float: 'right'
                }}
              >
                Imprimir
              </button>
              <div ref={printRef} style={{ clear: 'both' }}>
              {/* Cabeçalho com informações do produto */}
              <div style={{
                marginTop: 20,
                marginBottom: 10,
                padding: 16,
                background: '#f5f5f5',
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                fontSize: 16,
                color: '#2d3a4b',
                fontWeight: 500,
                display: 'flex',
                flexWrap: 'wrap',
                gap: '32px',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}>
                <div><b>Cliente:</b> {
                  ordemSelecionada.nomeCliente
                  || ordemSelecionada.clienteNome
                  || (ordemSelecionada.cliente && (ordemSelecionada.cliente.nomeCliente || ordemSelecionada.cliente.nome || ordemSelecionada.cliente.nomeFantasia))
                  || (ordemSelecionada.idCliente && (ordemSelecionada.idCliente.nomeCliente || ordemSelecionada.idCliente.nome || ordemSelecionada.idCliente.nomeFantasia))
                  || (ordemSelecionada.pedidoVenda && ordemSelecionada.pedidoVenda.idCliente && (ordemSelecionada.pedidoVenda.idCliente.nomeCliente || ordemSelecionada.pedidoVenda.idCliente.nome || ordemSelecionada.pedidoVenda.idCliente.nomeFantasia))
                  || '-'
                }</div>
                <div><b>Modelo:</b> {ordemSelecionada.nomeModelo || (ordemSelecionada.produto && ordemSelecionada.produto.nomeModelo) || '-'}</div>
                <div><b>Marca:</b> {ordemSelecionada.marca || (ordemSelecionada.produto && ordemSelecionada.produto.marca) || '-'}</div>
                <div><b>Referência:</b> {ordemSelecionada.referencia || (ordemSelecionada.produto && ordemSelecionada.produto.referencia) || '-'}</div>
                <div><b>Cor:</b> {ordemSelecionada.cor || (ordemSelecionada.produto && ordemSelecionada.produto.cor) || '-'}</div>
                <div><b>Mapa:</b> {ordemSelecionada.mapa || '-'}</div>
                <div><b>Quantidade Planejada:</b> {ordemSelecionada.quantidadePlanejada != null ? ordemSelecionada.quantidadePlanejada : '-'}</div>
                <div>
                  <b>Data de Início:</b> {
                    (() => {
                      const raw = ordemSelecionada.dataInicio || ordemSelecionada.dataEmissao;
                      if (!raw) return '-';
                      const d = new Date(raw);
                      if (isNaN(d.getTime())) {
                        console.log('Data de Início inválida:', raw);
                        return '-';
                      }
                      return d.toLocaleDateString();
                    })()
                  }
                </div>
                <div>
                  <b>Data de Fim:</b> {
                    (() => {
                      const raw = ordemSelecionada.previsaoTermino;
                      if (!raw) return '-';
                      const d = new Date(raw);
                      if (isNaN(d.getTime())) {
                        console.log('Data de Fim inválida:', raw);
                        return '-';
                      }
                      return d.toLocaleDateString();
                    })()
                  }
                </div>
                {/* Grade fixa: tamanhos (linha superior) e quantidades (linha inferior) */}
                <div style={{ minWidth: 220, padding: 12, background: '#fff', border: '1px solid #eee', borderRadius: 6 }}>
                  <div style={{ fontWeight: 700, marginBottom: 8 }}>Grade</div>
                  {gradeLoading ? (
                    <div>Carregando grade...</div>
                  ) : gradeError ? (
                    <div style={{ color: '#d32f2f' }}>Erro: {gradeError}</div>
                  ) : !grade || Object.keys(grade).length === 0 ? (
                    <div style={{ color: '#666' }}>Sem grade</div>
                  ) : (
                    (() => {
                      const numerosOrdenados = Object.keys(grade).sort((a, b) => {
                        const na = parseInt(a, 10), nb = parseInt(b, 10);
                        if (!isNaN(na) && !isNaN(nb)) return na - nb;
                        return a.localeCompare(b);
                      });
                      return (
                        <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center' }}>
                          <thead>
                            <tr>
                              {numerosOrdenados.map(n => (
                                <th key={n} style={{ border: '1px solid #ddd', padding: 6, fontSize: 13 }}>{n}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {numerosOrdenados.map(n => (
                                <td key={n} style={{ border: '1px solid #ddd', padding: 6 }}>{grade[n]}</td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      );
                    })()
                  )}
                </div>
              </div>
              {/* Tabela de insumos */}
              <div style={{ marginTop: 0, overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15 }}>
                  <thead>
                    <tr style={{ background: '#f5f5f5' }}>
                      <th style={{ border: '1px solid #ccc', padding: 6 }}>Nome do Material</th>
                      <th style={{ border: '1px solid #ccc', padding: 6 }}>Código</th>
                      <th style={{ border: '1px solid #ccc', padding: 6 }}>Unidade</th>
                      <th style={{ border: '1px solid #ccc', padding: 6 }}>Consumo Total</th>
                      <th style={{ border: '1px solid #ccc', padding: 6 }}>Componentes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {insumos.map((insumo, idx) => {
                      const item = normalizarInsumo(insumo);
                      return (
                        <tr key={idx}>
                          <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.nomeMaterial}</td>
                          <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.codigo}</td>
                          <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.unidade}</td>
                          <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.consumo}</td>
                          <td style={{ border: '1px solid #ccc', padding: 6 }}>{item.componentes}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
        </div>
        
        {/* Modal de Detalhes da Ficha Técnica */}
        <Dialog
          open={fichaModalOpen}
          onClose={() => setFichaModalOpen(false)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          fontWeight: 'bold'
        }}>
          📋 Detalhes da Ficha Técnica - {ordemSelecionada?.nomeModelo || ordemSelecionada?.produto?.nomeModelo || 'Produto'}
        </DialogTitle>
          <DialogContent id="fichas-para-imprimir" style={{ padding: '16px', marginTop: '8px', maxHeight: '85vh', overflowY: 'auto' }}>
          {fichaLoading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div className="spinner" style={{ margin: '0 auto' }}></div>
              <p>Carregando detalhes da ficha técnica...</p>
            </div>
          ) : fichaDetalhes.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              <Typography variant="h6">Nenhum item encontrado na ficha técnica</Typography>
            </div>
          ) : (
            <>
              {/* Renderizar uma ficha completa para cada componente/item */}
              {fichaDetalhes.map((item, idx) => (
                <div className="ficha-item" key={idx} style={{
                  marginBottom: 8,
                  padding: 6,
                  background: '#fff',
                  borderRadius: 4,
                  border: '1px solid #667eea',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  fontSize: '9px',
                  pageBreakAfter: 'auto'
                }}>
                  {/* Cabeçalho da Ficha */}
                  <div style={{ textAlign: 'center', marginBottom: 4, paddingBottom: 3, borderBottom: '1px solid #667eea' }}>
                    <Typography variant="body2" style={{ color: '#667eea', fontWeight: 'bold', fontSize: '9px' }}>
                      FICHA TÉCNICA - ITEM {idx + 1}
                    </Typography>
                  </div>

                  {/* Informações do Produto */}
                  <div style={{ marginBottom: 5 }}>
                    <Typography variant="caption" style={{ fontWeight: 'bold', color: '#333', marginBottom: 2, fontSize: '9px', display: 'block' }}>
                      📋 Informações do Produto
                    </Typography>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '2px',
                      fontSize: '8.5px'
                    }}>
                      <div><strong>Cliente:</strong> {
                        ordemSelecionada?.nomeCliente
                        || ordemSelecionada?.clienteNome
                        || (ordemSelecionada?.cliente && (ordemSelecionada.cliente.nomeCliente || ordemSelecionada.cliente.nome))
                        || (ordemSelecionada?.idCliente && (ordemSelecionada.idCliente.nomeCliente || ordemSelecionada.idCliente.nome))
                        || '-'
                      }</div>
                      <div><strong>Modelo:</strong> {ordemSelecionada?.nomeModelo || (ordemSelecionada?.produto && ordemSelecionada.produto.nomeModelo) || '-'}</div>
                      <div><strong>Marca:</strong> {ordemSelecionada?.marca || (ordemSelecionada?.produto && ordemSelecionada.produto.marca) || '-'}</div>
                      <div><strong>Referência:</strong> {ordemSelecionada?.referencia || (ordemSelecionada?.produto && ordemSelecionada.produto.referencia) || '-'}</div>
                      <div><strong>Cor Modelo:</strong> {ordemSelecionada?.cor || (ordemSelecionada?.produto && ordemSelecionada.produto.cor) || '-'}</div>
                      <div><strong>Mapa:</strong> {ordemSelecionada?.mapa || '-'}</div>
                      <div><strong>Quantidade Planejada:</strong> {ordemSelecionada?.quantidadePlanejada != null ? ordemSelecionada.quantidadePlanejada : '-'}</div>
                      <div><strong>Data de Início:</strong> {
                        (() => {
                          const raw = ordemSelecionada?.dataInicio || ordemSelecionada?.dataEmissao;
                          if (!raw) return '-';
                          const d = new Date(raw);
                          return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
                        })()
                      }</div>
                      <div><strong>Data de Fim:</strong> {
                        (() => {
                          const raw = ordemSelecionada?.previsaoTermino;
                          if (!raw) return '-';
                          const d = new Date(raw);
                          return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
                        })()
                      }</div>
                    </div>
                  </div>

                  {/* Grade */}
                  {grade && Object.keys(grade).length > 0 && (
                    <div style={{ marginBottom: 5 }}>
                      <Typography variant="caption" style={{ fontWeight: 'bold', color: '#333', marginBottom: 2, fontSize: '9px', display: 'block' }}>
                        📊 Grade
                      </Typography>
                      <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '8px' }}>
                        <thead>
                          <tr style={{ background: '#f0f0f0', borderBottom: '2px solid #667eea' }}>
                            {Object.keys(grade).sort((a, b) => {
                              const na = parseInt(a, 10), nb = parseInt(b, 10);
                              return !isNaN(na) && !isNaN(nb) ? na - nb : a.localeCompare(b);
                            }).map(n => (
                              <th key={n} style={{ border: '1px solid #ddd', padding: '2px', fontWeight: 'bold', textAlign: 'center' }}>{n}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {Object.keys(grade).sort((a, b) => {
                              const na = parseInt(a, 10), nb = parseInt(b, 10);
                              return !isNaN(na) && !isNaN(nb) ? na - nb : a.localeCompare(b);
                            }).map(n => (
                              <td key={n} style={{ border: '1px solid #ddd', padding: '2px', textAlign: 'center' }}>{grade[n]}</td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Detalhes do Componente */}
                  <div style={{
                    padding: 5,
                    background: '#f8f9fa',
                    borderRadius: 4,
                    border: '1px solid #667eea',
                    fontSize: '8.5px'
                  }}>
                    <Typography variant="caption" style={{ fontWeight: 'bold', color: '#667eea', marginBottom: 3, fontSize: '9px', display: 'block' }}>
                      🔹 Componente: {item.componentes || '-'}
                    </Typography>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '3px' }}>
                      <div>
                        <div style={{ color: '#666', fontSize: 8, marginBottom: 0 }}>Material</div>
                        <div style={{ fontWeight: 'bold', fontSize: 8.5, color: '#333' }}>
                          {item.materiaPrima?.descricao || '-'}
                        </div>
                      </div>

                      <div>
                        <div style={{ color: '#666', fontSize: 8, marginBottom: 0 }}>Cor</div>
                        <div style={{ fontWeight: 'bold', fontSize: 8.5, color: '#333' }}>
                          {item.materiaPrima?.cor || '-'}
                        </div>
                      </div>

                      <div>
                        <div style={{ color: '#666', fontSize: 8, marginBottom: 0 }}>Estrutura</div>
                        <div style={{ fontWeight: 'bold', fontSize: 8.5, color: '#333' }}>
                          {item.estrutura || '-'}
                        </div>
                      </div>

                      <div>
                        <div style={{ color: '#666', fontSize: 8, marginBottom: 0 }}>Tamanho</div>
                        <div style={{ fontWeight: 'bold', fontSize: 8.5, color: '#333' }}>
                          {item.tamanho || '-'}
                        </div>
                      </div>

                      <div style={{ gridColumn: '1 / -1' }}>
                        <div style={{ color: '#666', fontSize: 8, marginBottom: 0 }}>Consumo</div>
                        <div style={{ fontWeight: 'bold', fontSize: 9, color: '#667eea' }}>
                          {item.consumo != null ? Number(item.consumo).toFixed(4) : '-'} {item.unidade || item.materiaPrima?.umSigla || ''}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Separador */}
                  {idx < fichaDetalhes.length - 1 && (
                    <div style={{ marginTop: 20, paddingTop: 20, borderTop: '3px dashed #ccc', textAlign: 'center', color: '#999', fontSize: 12 }}>
                      ───────────────────────────────────────────────
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </DialogContent>
          <DialogActions style={{ padding: '16px 24px', gap: '12px' }}>
          <Button 
            onClick={handlePrintFichas}
            variant="contained"
            style={{
              background: '#2196F3',
              color: 'white',
              fontWeight: 'bold',
              padding: '8px 24px'
            }}
          >
            🖨️ Imprimir
          </Button>
          <Button 
            onClick={() => setFichaModalOpen(false)}
            variant="contained"
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              fontWeight: 'bold',
              padding: '8px 24px'
            }}
          >
            Fechar
          </Button>
        </DialogActions>
        </Dialog>
        </div>
      
    </>
  );
};

export default InsumosOrdemProducao;
